import { Component } from '@angular/core';
import { IBlog } from '../../../../shared/models/dtos/get/blog.interface';
import { BlogService } from '../../../../shared/services/transactional/blog/blog.service';
import { finalize } from 'rxjs';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChevronLeft,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { NavbarControlComponent } from '../../../../shared/controls/navbar-control/navbar-control.component';

@Component({
  selector: 'app-blog',
  imports: [FontAwesomeModule, RouterModule, NavbarControlComponent],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss',
})
export class BlogComponent {
  public isLoaded: boolean = false;
  public blog: IBlog = null!;
  public faChevronLeft: IconDefinition = faChevronLeft;
  public safeContent: SafeHtml = ''; // ✅ Define safeContent as SafeHtml

  constructor(
    private _blogService: BlogService,
    private _route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private _title: Title,
  ) {}
  public ngOnInit(): void {
    let slug = this._route.snapshot.params['slug'];

    this._blogService
      .find(slug)
      .pipe(
        finalize(() => {
          this.isLoaded = true;
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.isSuccess) {
            if (response.data) {
              this.blog = response.data;
              this._title.setTitle(`ClockFlex - ${this.blog.title}`);

              this.safeContent = this.sanitizer.bypassSecurityTrustHtml(
                this.blog.content,
              );
            }
          }
        },
      });
  }
}
